import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';

import { MetricBarChart, PageSection } from '@occc/ui-design-system';
import { TimeSeriesMetric } from '@occc/graphql';

import { StoreDowntimeChartTooltip } from './store-downtime-chart-tooltip';
import { getDowntimeMetrics } from './store-downtime-chart.utils';
import { DowntimeMetricPoint } from './store-downtime-chart.types';

export type StoreDowntimeChartProps = {
  data: TimeSeriesMetric[];
  isLoading?: boolean;
  hasError?: boolean;
  title?: string;
  description?: string;
};

export const StoreDowntimeChart = ({ data, isLoading, hasError }: StoreDowntimeChartProps) => {
  const theme = useTheme();
  const metrics: DowntimeMetricPoint[] = useMemo(() => getDowntimeMetrics(data), [data]);

  return (
    <PageSection
      title='Store Downtime'
      description='Monitor store connectivity in the last 30 days'
      isLoading={isLoading}
      hasError={hasError}
      contentSx={{ p: 2, pt: 3 }}
    >
      <MetricBarChart
        metrics={metrics}
        height={180}
        isBarStacked
        barColor={[theme.palette.error.main, theme.palette.warning.main, theme.palette.info.main]}
        noDataLabel={'We’re still gathering connection status for this location. Check back soon'}
        isLegendVisible={false}
        tickCount={5}
        tooltipContent={<StoreDowntimeChartTooltip />}
        metricsType='time'
      />
    </PageSection>
  );
};
